<template>
  <div :class="isRightPosition ? '' : 'comment-scroll custom-scroll'" style="height:100%;background-color: #f9f9f9;">
  <ul :class="isRightPosition ? 'comment-scroll custom-scroll' : ''" style="padding:0 8px;
    width: 100%;
    list-style: none;
    word-break: break-word;
    margin-bottom:0;
    display: flex;
    flex-direction: column-reverse;" :style="ulStyle">
    <div v-if="commentList.length === 0" style="padding:20px"><!--/* まだコメントがありません、と書いてもあとで出る可能性がある*/--></div>
    <li v-else
      class="comment-item"
      v-for="(cmt, idx) in this.isRightPosition ? this.commentListReverse: this.commentList"
      :class="getLiClass(idx)"
      :key="cmt.commentId"
    >
      <div class="comment-layout">
        <router-link
          :to="'/' + cmt.user.userName"
          style="padding-left: 0; padding-right: 0.5rem; display: inline-block"
        >
          <img
            class="comment-image" style="border-radius: 50%"
            :src="urls.getUserImageSrc(cmt.user)"
            alt="username"
          />
        </router-link>
        <div>
          <div class="user-name">{{ cmt.user.userName }}</div>
          <div>{{ cmt.comment }}</div>
          <!--/* デバッグ用。
          <div style="font-size:small">{{cmt.sceneMilliSecond}}</div>
          */-->
        </div>
      </div>
    </li>
  </ul>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import CommentResp from '@/interface/api/CommentResp';
import { Watch } from 'vue-property-decorator';
import urls from "@/URLs";

@Options({
  props: {
    isPreview: {
      type: Boolean,
    },
    isRightPosition:{
      type: Boolean
    }
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  readonly isPreview?: boolean;
  readonly isRightPosition?: boolean;
  readonly urls = urls;
  
  commentList: CommentResp[] = [];
  commentListReverse: CommentResp[] = [];//スクロールバーを一番下に固定するためには、CSSで頑張るよりも逆配列を作るほうが簡単なので。
  lenOnLayoutChanged = 0
  @Watch("isRightPosition", { immediate: false, deep: false })
  onLayoutChange(){
    this.lenOnLayoutChanged = this.commentList.length
  }

  getLiClass(idx:number){
    let ret = ""
    //新たに追加するコメントにのみ表示時にアニメーションクラスを付与する
    if(this.isRightPosition){
      //右側のコメント欄は配列の後ろから項目を追加している
      ret = 'right-comment-item ' + (this.commentList.length - this.lenOnLayoutChanged > idx ? 'animation-in': '')
    }else{
      ret = 'bottom-comment-item ' + (this.lenOnLayoutChanged <= idx ? 'animation-in': '')
    }
    return ret;
  }

  get ulStyle(){
    return this.isRightPosition ? {
      'height': '100%' //右側の場合は、こいつ自体がスクロールバーを持つので高さ固定
    }:{
      'min-height': '100%'//下側の場合は、親要素がスクロールバーを持つのでmin指定
    }
  }


  public addComment(comment: CommentResp){
    this.commentList.push(comment)
    this.commentListReverse.unshift(comment)
  }
  
  getPreviewComment(){
    return [
      {
        user: this.$root.account.info,
        comment : "ここにコメントが表示されます"
      },
      {
        user: this.$root.account.info,
        comment : "投稿時の条件と時間により表示タイミングが決まります"
      },
      
    ] as any[]
  }

  created(){
    if(this.isPreview){
      this.commentList = this.getPreviewComment();
      this.commentListReverse = this.getPreviewComment().reverse();
    }
  }
}
</script>

<style lang="scss" scoped>

.comment-item{
  display: flex;
}
.right-comment-item{
  padding-bottom:8px;
  align-items: flex-start;//heigh=0の時にコンテンツが下側に表示されるようする（heightが増えた時に画面外から上方向に表示したいため）
}

.bottom-comment-item{
  padding-top:8px;
  align-items: flex-end;//heigh=0の時にコンテンツが上側に表示されるようする（heightが増えた時に画面外から下方向に表示したいため）
}
.bottom-comment-item:first-child{
  margin-bottom: auto;
}

.animation-in {
animation-name: animationkey;
animation-fill-mode:backwards;//アニメーション終了後にアニメーションに使用していた設定値（height）は破棄する
animation-duration:0.15s;
animation-timing-function:ease-in;//ease,ease-in,linear
}

@keyframes animationkey{
  0% {
    height: 0;
  }

  100% {
    height: 58px;//最小高さ（画像50px + padding:8px）
  }
}


.comment-scroll{
  overflow-y:scroll;
  margin-top: 0;
}

/*スクロールバー全体*/
.comment-scroll::-webkit-scrollbar {
  width: 8px;
}

/*スクロールバーの動く部分*/
.comment-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, .2);
  border-radius: 10px;
}


.comment-layout{
  display: flex;
  align-items: center;
}
.comment-image{
  width: 50px; 
  height: 50px;
}

.user-name{
  font-size: 14px;
  color:#333;
  font-weight:600;
} 
</style>
